export const IconCloud = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconCloud_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconCloud_svg__a)">
        <path d="M11 12.15V6.1q-1.9.35-2.95 1.837T7 11h-.5q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 3 14.5q0 1.45 1.025 2.475A3.37 3.37 0 0 0 6.5 18h12q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-1.2-.55-2.238A5.6 5.6 0 0 0 15 7V4.675a6.83 6.83 0 0 1 2.925 2.587A6.9 6.9 0 0 1 19 11q1.725.2 2.863 1.488A4.4 4.4 0 0 1 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20h-12q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475Q3.349 9.575 5.25 9.15q.425-1.8 2.125-3.425T11 4.1q.825 0 1.412.587Q13 5.275 13 6.1v6.05l.9-.875a.93.93 0 0 1 .688-.275q.412 0 .712.3a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-2.6 2.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.6-2.6a.98.98 0 0 1-.287-.687.93.93 0 0 1 .287-.713.98.98 0 0 1 .688-.288.97.97 0 0 1 .712.263z" />
      </g>
    </svg>
  );
};
